import React from 'react';
import { Box } from '@mui/material';
import { useRecaptchaField } from '../../contexts/recaptchaField';
import Recaptcha from 'react-recaptcha';
import secureLocalStorage from 'react-secure-storage';
import { ValidarFormulario } from 'pages/Login';

const RecaptchaField = () => {
  const { setCaptchaRef, captchaRef } = useRecaptchaField();
  let captcha: any;

  return (
    <Box display="flex" flexDirection="column" alignItems="center" width="100%">
      <Recaptcha
        ref={(r) => setCaptchaRef(r)}
        sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY}
        render="explicit"
        onloadCallback={() => { }}
        verifyCallback={(newValue) => {
          secureLocalStorage.setItem('@grecaptcha', newValue);
          ValidarFormulario();
        }}
        expiredCallback={() => {
          captchaRef?.reset();
          ValidarFormulario();
        }}
        hl="pt-BR"
      />
    </Box>
  );
};

export default RecaptchaField;
